export enum EUserClaim {
    mode_desktop
}
